module.exports = __webpack_public_path__ + "media/images/no-access-button-d4a2a8a545e21b98209d600e7ad520f6.png";